module.exports = __webpack_public_path__ + "assets/dripicons-v2.11fc83ae11617015f2fcde2065fb34d3.woff";